import PropTypes from 'prop-types'

import { ProgresSpinner } from './ProgresSpinner'
import { Flex, Form, Select, Spin } from 'antd'

const SelectInput = ({
  isMulti = false,
  isRequired = true,
  onChange = () => {},
  options = [],
  optionCache,
  onInputChange = () => {},
  filterOption = undefined,
  formatLabel = undefined,
  label,
  name,
  value,
  initialValue,
  placeholder,
  formatOption,
  showLoader = false,
  onMenuOpen = () => {},
  wrapperClass = '',
  allowClear = true,
  showSearch = true,
  disabled = false,
  hideLabel = false,
  errorHelp = false,
  errorMsg = '',
}) => {
  return (
    <Form.Item
      name={name}
      label={label ? label : ''}
      className={`${wrapperClass} ${hideLabel ? 'hide-label' : ''}`}
      style={{ marginBottom: 0, minWidth: 0 }}
      initialValue={initialValue}
      rules={
        isRequired
          ? [
              {
                required: true,
                message:
                  errorHelp === false
                    ? ''
                    : errorMsg.length > 0
                      ? errorMsg
                      : `Please enter "${label}"`,
              },
            ]
          : undefined
      }
      {...(errorHelp === false ? { help: '' } : {})}
    >
      <Select
        mode={isMulti ? 'multiple' : undefined}
        //value={value}
        {...(value !== undefined ? { value } : {})}
        options={(() => {
          const normalizedOptions = options.map((option) => {
            return {
              ...option,
              label: option.label,
              value: option.value,
            }
          })

          return normalizedOptions
        })()}
        placeholder={placeholder || label}
        aria-label={label ? label : placeholder}
        loading={showLoader}
        allowClear={allowClear}
        showSearch={showSearch}
        disabled={disabled}
        {...(showSearch
          ? {
              onSearch: (value) => {
                onInputChange(value)
              },
            }
          : {})}
        onOpenChange={(open) => {
          if (open) {
            onMenuOpen()
          }
        }}
        filterOption={(input, option) => {
          if (filterOption) {
            return filterOption(input, option)
          }

          return option.label?.toLowerCase().includes(input.toLowerCase())
        }}
        onChange={(value) => {
          if (isMulti) {
            const selectedOptions = options.filter((o) =>
              value.includes(o.value)
            )
            onChange(selectedOptions)
            return
          }

          const option = options.find((o) => o.value === value)
          onChange(option)
        }}
        optionRender={(option) => {
          if (!option?.data) return null

          const data = option.data
          return formatOption ? formatOption(data) : data.label
        }}
        labelRender={(selectedOption) => {
          if (!selectedOption?.value) return null

          const orgOption = optionCache
            ? optionCache[selectedOption.value]
            : options.find((o) => {
                return o.value === selectedOption.value
              })

          if (!orgOption) return selectedOption.label

          return formatLabel ? formatLabel(orgOption) : orgOption.label
        }}

        /* labelRender={(selectedOption) => {
          if (!selectedOption?.value) return null

          const option = options.find((o) => {
            // console.log(`Compare | ${o.value} === ${selectedOption.value} = ${o.value === selectedOption.value}`)
            return o.value === selectedOption.value
          })
          
          return formatLabel ? formatLabel(option) : selectedOption.label
        }} */

        /* labelRender={(selectedOption) => {
          const value = typeof selectedOption === 'string' ? selectedOption : selectedOption?.value
          console.log(`LR: ${value} | Type: ${typeof(value)}`)
          if(!value) return null

          const option = options.find((o) => o.value === value)
          return formatLabel ? formatLabel(option) : option?.label
        }} */
      />
    </Form.Item>
  )
}

SelectInput.propTypes = {
  className: PropTypes.string,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  value: PropTypes.any,
  initialValue: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  options: PropTypes.array,
  optionCache: PropTypes.object,
  formatOption: PropTypes.func,
  formatLabel: PropTypes.func,
  showLoader: PropTypes.bool,
  wrapperClass: PropTypes.string,
  onMenuOpen: PropTypes.func,
  onInputChange: PropTypes.func,
  allowClear: PropTypes.bool,
  showSearch: PropTypes.bool,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  errorHelp: PropTypes.bool,
  errorMsg: PropTypes.string,
}

export default SelectInput
